import IUserFilter from "interfaces/IUserFilter";
import { UserQuickFilter } from "interfaces/models/UserQuickFilter";

const initialUserFilter = () : IUserFilter => ({
  groups: [],
  userTypes: [],
  quickFilter: UserQuickFilter.All,
  searchText: ""
});

export { initialUserFilter };
